import { isDesignKit, isIntl } from '@meitu/x-design-ai-shared-config';
import { getRuntimeEnv, isDevelopEnv } from '../config';
import type { CutoutInfo, UserInfoData } from './api';
import { IMeidouInfo, IUserInfo, IVipInfoInfo } from './types';

export function getCallbackURL() {
    return isDevelopEnv() || getRuntimeEnv().isCustomized
        ? `${window.location.protocol}//${window.location.host}/callback.html`
        : isDesignKit() && isIntl()
          ? `${window.location.protocol}//${window.location.host}/account-callback.html`
          : `${window.location.protocol}//${window.location.host}/design/callback.html`;
}

/** 将账号接口的蛇形字段统一转换为前端 Store 使用的会员与用户模型。 */
export function transformUserInfo(data: UserInfoData | null): {
    userInfo: IUserInfo | null;
    meidouInfo: IMeidouInfo | null;
    vipInfo: IVipInfoInfo | null;
    cutoutInfo: CutoutInfo | null;
    identification: string;
} {
    if (!data) {
        return {
            userInfo: null,
            meidouInfo: null,
            cutoutInfo: null,
            vipInfo: null,
            identification: '',
        };
    }

    return {
        userInfo: {
            id: data.userInfo.id,
            name: data.userInfo.screen_name,
            gender: data.userInfo.gender,
            avatar: data.userInfo.avatar,
            isVip: data.vipInfo.is_vip,
            stage: data.vipInfo.stage,
            isXXVip: data.vipInfo.is_xx_vip,
            vipExpiresAt: data.vipInfo.vip_end_time,
            vipDays: data.vipInfo.vip_days,
            promotionContent: data.promotionContent,
            vmakeUser: data.userInfo.vmake_user,
            email: data?.userInfo?.email || '',
            isSubscribe: Boolean(data.vipInfo?.is_subscribe),
            vipLevel: data.vipInfo.vip_level,
            isCompensation: Boolean(data.vipInfo?.is_compensation),
            hasTrial: Boolean(data.vipInfo?.has_trial),
            identification: data.identification || '',
            lawrence: data.lawrence || '',
            timestamp: data.timestamp || '',
            educationRole: data.education_role,
        },
        meidouInfo: {
            availableAmount: data.coinInfo.available_amount,
            totalAmount: data.coinInfo.total_amount,
        },
        vipInfo: {
            expireTimestamp: data.vipInfo.vip_end_time,
            isVip: data.vipInfo.is_vip,
            stage: data.vipInfo.stage,
            vipEndTime: data.vipInfo.vip_end_time,
            isHbpVip: data.vipInfo.is_hbp_vip,
            isXxVip: data.vipInfo.is_xx_vip,
            vipDays: data.vipInfo.vip_days,
            vipLevel: data.vipInfo.vip_level,
            deriveFrom: data.vipInfo.derive_from,
        },
        cutoutInfo: data.cutoutInfo,
        identification: data.identification,
    };
}

const SILENT_TOKEN_KEY_FOR_SDK = 'access_token_silent';
const SILENT_TOKEN_PREFIX = 'access_token_silent_';

/**
 * Get silent token key
 * @param customID
 * @returns `localStorage` key for user access token in service market env.
 */
export const getCustomSilentTokenKey = (customID: string) => {
    return `${SILENT_TOKEN_PREFIX}${customID}`;
};

/**
 * Get silent token key
 * @returns `localStorage` key for user access token (silent login)
 */
export const getAccountSilentTokenKey = () => {
    if (getRuntimeEnv().isInSDK) {
        return SILENT_TOKEN_KEY_FOR_SDK;
    }

    const customizedConfig = getRuntimeEnv().customizedConfig;

    if (getRuntimeEnv().isCustomized && customizedConfig) {
        return getCustomSilentTokenKey(customizedConfig.id);
    }

    return '';
};

// 1 test, 0 线上（默认）, 2 beta
export function getEnvValue(env?: string) {
    let value;
    switch (env) {
        case 'release':
            value = 0;
            break;
        case 'beta':
            value = 2;
            break;
        default:
            value = 1;
    }
    return value;
}

export const LOGIN_COVER_WITH_LOCALE_CONFIG_CN = {
    'zh-Hans': {
        cover: 'https://public.static.meitudata.com/xiuxiu-pc/x-design/videoframe_1193.jpg',
        video: 'https://public.static.meitudata.com/xiuxiu-pc/x-design/login-banner2.webm',
    },
    en: {
        cover: 'https://xiuxiu-pro-new.meitudata.com/poster/84053d9139882d9d66c12d2bad8a1b5c.png',
        video: 'https://public.static.meitudata.com/xiuxiu-pc/x-design/login-banner-en.webm',
    },
};
